// src/components/NewsList.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { database  } from "../firebase";

const NewsList = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const newsCollection = await database.collection('news').orderBy('createdAt', 'desc').get();
      setNews(newsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchData();
  }, []);

  return (
    <div>
      <h1>News Articles</h1>
      {news.map((article) => (
        <div key={article.id}>
          <h2><Link to={`/article/${article.id}`}>{article.title}</Link></h2>
          <h3>{article.subTitle}</h3>
          <p>{article.content.substring(0, 100)}...</p>
          <p><strong>Meta Tags:</strong> {article.metaTags.join(', ')}</p>
          {article.metaImage && <img src={article.metaImage} alt={article.title} style={{ width: '200px' }} />}
        </div>
      ))}
    </div>
  );
};

export default NewsList;
